import { LanguageCode } from "../domain/i18n/language-code.js";
import es_DO_default from "./es_DO.js";
import es_GT_default from "./es_GT.js";
import es_HN_default from "./es_HN.js";
//#region src/translations/translations.ts
var translations = {
	[LanguageCode.ES_GT]: { ...es_GT_default },
	[LanguageCode.ES_DO]: { ...es_DO_default },
	[LanguageCode.ES_HN]: { ...es_HN_default }
};
//#endregion
export { translations };

//# sourceMappingURL=translations.js.map